import {
  getAuth,
  signOut,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import router from "@/router";
import { db } from "@/firebase";
import {
  doc,
  getDoc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  setDoc,
} from "firebase/firestore";

import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
const auth = getAuth();

const users = {
  state: { userProfile: null },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setPreviewSize(state, val) {
      state.userProfile.preferences.preview_size = val;
    },
    setPreferences(state, val) {
      state.userProfile.preferences[val.type] = val.val;
    },
    setFeed(state, val) {
      state.userProfile.preferences.feed = val;
    },
    setRole(state, val) {
      state.userProfile.role = val;
    },
    setTitle(state, val) {
      state.userProfile.job_title = val;
    },
    setName(state, val) {
      state.userProfile.first_name = val.first_name;
      state.userProfile.last_name = val.last_name;
      state.userProfile.name = val.first_name + " " + val.last_name;
    },
    setInvites(state, val) {
      state.invites = val;
    },
    removeWorkspaceInvite(state, val) {
      let i = state.userProfile.invites.findIndex(
        (inv) => inv.workspace === val.workspace,
      );
      state.userProfile.invites.splice(i, 1);
    },

    setUserRole(state, val) {
      console.log("setting user role");
      state.userProfile.role = val;
    },
  },
  actions: {
    updateUserRole({ commit }, val) {
      commit("setUserRole", val);
    },
    async acceptWorkspaceInvite({ commit, dispatch }, inv) {
      console.log("accepting workspace invite");
      console.log(inv);
      commit("setLoading", { type: "general", val: true });
      commit("removeWorkspaceInvite", inv);

      const acceptWorkspaceInvite = httpsCallable(
        functions,
        "acceptWorkspaceInvite",
      );

      const res = await acceptWorkspaceInvite({
        invite: inv,
      });
      console.log(res);
      const auth = getAuth();
      const user = auth.currentUser;
      await new Promise((resolve) => setTimeout(resolve, 3000));
      dispatch("fetchUserProfile", user);
      commit("setLoading", { type: "general", val: false });
      return res.data;
    },
    async declineWorkspaceInvite({ commit, state }, inv) {
      commit("removeWorkspaceInvite", inv);
      const ref = doc(db, "users", state.userProfile.uid);
      await updateDoc(ref, {
        invites: arrayRemove(inv),
      });
      return 200;
    },
    async updateSubscriptionWorkspaces({ state, dispatch }, val) {
      const ref = doc(db, "users", state.userProfile.uid);
      await updateDoc(ref, {
        "subscription.workspaces": val,
      });
      dispatch("fetchWorkspace");
      return 200;
    },
    async updateFeed({ state, commit }, val) {
      const ref = doc(db, "users", state.userProfile.uid);
      let feed = state.userProfile.preferences.feed;

      if (val.type === "add") {
        feed.push(val.value);
        await updateDoc(ref, {
          "preferences.feed": arrayUnion(val.value),
        });
      } else if (val.type === "remove") {
        let i = feed.findIndex((a) => a === val.value);

        await updateDoc(ref, {
          "preferences.feed": arrayRemove(val.value),
        });
        feed.splice(i, 1);
      }

      commit("setFeed", feed);
    },
    async updateRole({ commit, dispatch, state, rootState }, val) {
      if (val.invited) {
        let invites = rootState.workspace.workspace.invites;
        let i = invites.findIndex((inv) => (inv.email = val.email));
        invites[i].role = val.role;

        await setDoc(
          doc(db, "workspaces", state.userProfile.workspace),
          { invites: invites },
          { merge: true },
        );
        commit("setNotification", {
          show: true,
          text: `Role of ${val.email} changed to ${val.role}!`,
          type: "primary",
        });
      } else {
        const ref = doc(db, "users", val.uid);
        await updateDoc(ref, {
          role: val.role,
        });
        commit("setNotification", {
          show: true,
          text: `Role of ${val.first_name} changed to ${val.role}!`,
          type: "primary",
        });
      }

      dispatch("fetchWorkspace");
    },
    async updateTitle({ commit, state }, val) {
      const ref = doc(db, "users", state.userProfile.uid);
      await updateDoc(ref, {
        job_title: val,
      });

      commit("setTitle", val);

      commit("setNotification", {
        show: true,
        text: `Job title updated!`,
        type: "primary",
      });
    },
    async updateName({ commit, state }, val) {
      const ref = doc(db, "users", state.userProfile.uid);
      await updateDoc(ref, {
        first_name: val.first_name,
        last_name: val.last_name,
        name: val.first_name + " " + val.last_name,
      });

      commit("setName", val);

      commit("setNotification", {
        show: true,
        text: `Name updated!`,
        type: "primary",
      });
    },
    async updateNotifications({ state, commit }, val) {
      const ref = doc(db, "users", state.userProfile.uid);
      await updateDoc(ref, {
        [`preferences.notifications.${val.type}`]: val.val,
      });
      commit("setPreferences", val);
    },
    async setPreviewSize({ commit, state }, size) {
      const ref = doc(db, "users", state.userProfile.uid);

      await updateDoc(ref, {
        "preferences.preview_size": size,
      });
      commit("setPreviewSize", size);
    },
    async fetchUserProfile({ commit, dispatch }, user) {
      const now = new Date();
      commit("setLoading", { type: "general", val: true });
      commit("setLoading", { type: "userProfile", val: true });
      const docRef = doc(db, "users", user.uid);
      const userProfile = await getDoc(docRef);
      if (!userProfile.exists()) {
        commit("setLoading", { type: "general", val: false });
        return;
      }
      const fetchedUser = userProfile.data();
      console.log("fetched user");
      console.log(fetchedUser);
      commit("setUserProfile", fetchedUser);

      // Identify user for analytics
      import("@/utils/analytics").then(({ identifyUser }) => {
        identifyUser({
          identification: user.uid,
        });
      });

      commit("setLoading", { type: "userProfile", val: false });
      dispatch("fetchCustomerId");
      if (fetchedUser.superadmin) {
        await dispatch("fetchAdmin");
      }
      if (user.emailVerified && fetchedUser.workspace) {
        await dispatch("fetchWorkspace", null, { root: true });
        dispatch("fetchAccounts");
        dispatch("fetchTemplates");
        dispatch("fetchChat");
        dispatch("fetchTickets");
        dispatch("getSettings");
        dispatch("fetchKnowledgeItems");
        let promises = [
          // await dispatch("fetchAdminArticles"),
          dispatch("fetchCategories"),
          dispatch("fetchPosts"),
          // dispatch("fetchEvents"),
          dispatch("fetchMedia"),
          dispatch("getCalendarDays"),
          dispatch("fetchNotifications"),
          dispatch("fetchSchedules"),

          dispatch("fetchIdeas"),
          dispatch("fetchStructures"),
        ];

        await Promise.all(promises);
      }

      await updateDoc(docRef, {
        last_login: Math.round(Date.now() / 1000),
      });
      console.log(
        "router.currentRoute.value.path",
        router.currentRoute.value.path,
      );
      if (user.email && !user.emailVerified) {
        router.push("/verify");
      } else if (
        !fetchedUser.workspace &&
        !router.currentRoute.query?.workspace
      ) {
        router.push("/create-workspace");
      } else if (router.currentRoute.value.path === "/create-workspace") {
        commit("setNotification", {
          show: true,
          text: "Workspace created successfully!",
          type: "primary",
          icon: "clapping-hands",
        });
        console.log("pushing to onboarding");
        router.push("/onboarding");
      } else if (
        router.currentRoute.value.path === "/access" ||
        router.currentRoute.value.path.includes("/waiting-list")
      ) {
        console.log("pusing to library");
        if (fetchedUser.workspace && !router.currentRoute.query?.workspace) {
          commit("setNotification", {
            show: true,
            text: "Login successful!",
            type: "primary",
            icon: "clapping-hands",
          });
          router.push("/");
        } else if (router.currentRoute.query?.workspace) {
          router.replace({
            name: "Join",
            query: {
              workspace: router.currentRoute.query.workspace,
              name: router.currentRoute.query.name,
            },
          });
        }
      }

      const end = new Date();
      console.log(end - now);
      commit("setLoading", { type: "general", val: false });
    },
    async logout({ commit }) {
      console.log("logging out");
      const auth = getAuth();
      await signOut(auth);
      commit("setLoading", { type: "general", val: true });
      commit("setUserProfile", null);
      commit("setWorkspace", null);
      commit("setAccounts", []);
      commit("setIdeas", []);
      commit("setMediaTags", []);
      commit("setSchedules", []);
      commit("setIdeaTags", []);
      commit("setCalendar", []);
      commit("setPosts", []);
      commit("setCategories", []);
      commit("setSchedule", []);
      commit("setEvents", []);
      commit("setNotifications", []);
      commit("setMedia", []);
      commit("setLoading", { type: "general", val: false });

      router.replace("/access");
    },
    async signupWithEmail({ dispatch }, form) {
      console.log("Signing up new user");
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        form.email,
        form.password,
      );
      let user = userCredential.user;
      console.log(user);

      // Check brands for trial
      const brands = await getDoc(doc(db, "settings", "trial"));
      const trial_brands = brands.data().brands;

      // CREATING USER DOC
      try {
        await setDoc(doc(db, "users", user.uid), {
          first_name: form.first_name,
          last_name: form.last_name,
          name: `${form.first_name} ${form.last_name}`,
          email: form.email,
          created_at: Math.round(Date.now() / 1000),
          workspace: form.workspace,
          workspaces: form.workspaces,
          last_login: Math.round(Date.now() / 1000),
          notifications: [],
          subscription: {
            brands: trial_brands,
            mrr: null,
            plan: null,
            status: "active",
            trial: true,
            active: true,
            workspaces: [],
          },
          referrals: [],
          uid: user.uid,
          avatar: null,
          preferences: {
            feed: [],
            notifications: {
              newsletter: form.newsletter,
              summary: true,
              ideas: true,
            },
            preview_size: "small",
          },
        });

        // FETCH USER & REDIRECT
        dispatch("fetchUserProfile", user);
        return 200;
      } catch (error) {
        console.log(error);
        return 500;
      }
    },
  },
  getters: {},
};

export default users;
